import { getI18n } from "react-i18next";
import { updateFeedbackMessages, validUpdateFeedback, type UpdateFeedbackDescriptor } from "../../../../src/lib/contracts/updateFeedbackPresentation";
import { renderNotificationExpression } from "../../../../src/lib/contracts/notificationPresentation";
import { sharedFeedbackValue, sharedFeedbackText, isSharedRemoteFeedback } from "./sharedFeedbackPresentation";
export type UpdateRemoteFeedback = { remote: true; fallback: string; descriptor: UpdateFeedbackDescriptor };
const record = (value: unknown): value is Record<string, unknown> => !!value && typeof value === "object" && !Array.isArray(value)
  && (Object.getPrototypeOf(value) === Object.prototype || Object.getPrototypeOf(value) === null);
export function updateFeedbackValue(fallback: string, descriptor: unknown): UpdateRemoteFeedback | undefined {
  const shared = sharedFeedbackValue(fallback, descriptor);
  if (shared) return shared;
  return validUpdateFeedback(descriptor) ? { remote: true, fallback, descriptor: structuredClone(descriptor) } : undefined;
}
export function updateFeedbackText(value: UpdateRemoteFeedback): string {
  const { fallback, descriptor } = value;
  if (isSharedRemoteFeedback(value)) return sharedFeedbackText(value);
  if (!validUpdateFeedback(descriptor)) return fallback;
  const engine = getI18n(); const locale = engine?.resolvedLanguage ?? engine?.language ?? "en";
  const catalog: Record<string, string> = engine?.isInitialized ? engine.getResourceBundle(locale, "updates") ?? updateFeedbackMessages : updateFeedbackMessages;
  try { return renderNotificationExpression(descriptor, updateFeedbackMessages, catalog, locale) ?? fallback; }
  catch { return fallback; }
}
export function updateResponseFailure(response: unknown): UpdateRemoteFeedback | string | null {
  if (!record(response)) return null;
  const nested = record(response.error) ? response.error : response;
  const fallback = typeof nested.message === "string" ? nested.message : typeof nested.error === "string" ? nested.error : typeof response.message === "string" ? response.message : null;
  if (fallback === null) return null;
  return updateFeedbackValue(fallback, nested.messagePresentation ?? response.messagePresentation) ?? fallback;
}
